import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { Moment } from 'moment-timezone';
import { ReactElement } from 'react';
import { S_CollapseSection } from '../../../../../design/sections/collapseSection/S_CollapseSection';
import { WorkPerformanceStatsTableContainer } from './table/WorkPerformanceStatsTable.container';

interface IProps {
  endDate: Moment;
  startDate: Moment;
}

export const WorkPerformanceSection = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { startDate, endDate } = props;
  const subtitle = `(${startDate.format('DD MMMM yyyy')} - ${endDate.format('DD MMMM yyyy')})`;
  return (
    <S_CollapseSection
      title={t('projects.details.stats.work_performance.section_title')}
      subtitle={subtitle}
    >
      <WorkPerformanceStatsTableContainer />
    </S_CollapseSection>
  );
});
